import { AnalyticsService } from "../self-assesment/SelfAssesment";

export async function StartMyra(setIsMicModalActive, setIsMyRAIsActive) {
  window.isUserChatWithMyra = true;
  window.isStartedLandingFlow = true;

  localStorage.removeItem("userCondition");

  if (window.mayraCode && window.mayraCode.handleHomeScreenMyraClick) {
    // Set these BEFORE calling handleHomeScreenMyraClick
    window.setIsMicModalActive = setIsMicModalActive;
    window.updateMyRAIsActive = setIsMyRAIsActive;

    if (window.preloadAllAudios) {
      window.preloadAllAudios();
    }
    if (window.videoUnlockPlay) {
      window.videoUnlockPlay();
    }
    if (window.mayraCode) {
      window.mayraCode.setOnMicEnabled(null);
    }

    // ONE-TIME CALLBACK - will be cleared after execution
    window.mayraCode.setOnMicEnabled((enabledBefore) => {
      console.log("HomeScreen: Microphone enabled callback triggered, enabledBefore:", enabledBefore);

      // CLEAR THE CALLBACK IMMEDIATELY to prevent next screen from using it
      window.mayraCode.setOnMicEnabled(null);

      const handleFlowStart = () => {
        window.mayraCode.setIsVisible(true);
        window.mayraCode.setIsFlowStarted(true);
        if (!window.trSessionId) {
          console.log("HomeScreen: No session ID found, starting new session.");
          AnalyticsService.startSession();
        }

        const checkAndStartFlow = () => {
          const isAudioReady = window.audioPlayer?.unlocked && window.audioPlayer?.ctx?.state === "running";
          if (isAudioReady) {
            window.mayraCode.startFlow("flow_landing_page");
          } else {
            console.log("HomeScreen: Audio not ready (ctx state:", window.audioPlayer?.ctx?.state, ")");
            if (window.audioPlayer?.ctx?.state === "suspended") {
              window.audioPlayer.initFromUserGesture();
            }
            setTimeout(checkAndStartFlow, 200);
          }
        };

        checkAndStartFlow();
      };

      setTimeout(handleFlowStart, 300);
    });

    // Call the handler
    await window.mayraCode.handleHomeScreenMyraClick(true);
  } else {
    // Fallback logic
    console.log("handleHomeScreenMyraClick not available, using fallback");

    let micPermissionState = "prompt";
    try {
      if (navigator.permissions && navigator.permissions.query) {
        const status = await navigator.permissions.query({ name: "microphone" });
        micPermissionState = status.state;
      }
    } catch (e) {
      console.log("Permission query failed");
    }

    if (micPermissionState === "granted") {
      setIsMyRAIsActive(true);
      if (window.mayraCode) {
        window.mayraCode.setOnMicEnabled((enabledBefore) => {
          // CLEAR THE CALLBACK IMMEDIATELY
          window.mayraCode.setOnMicEnabled(null);

          window.mayraCode.setIsVisible(true);
          if (window.preloadAllAudios) window.preloadAllAudios();
          if (window.videoUnlockPlay) window.videoUnlockPlay();
          if (!window.trSessionId) {
            console.log("HomeScreen: No session ID found, starting new session.");
            AnalyticsService.startSession();
          }

          const checkAndStart = () => {
            if (window.audioPlayer?.unlocked) {
              window.mayraCode.startFlow("flow_landing_page");
            } else {
              setTimeout(checkAndStart, 500);
            }
          };
          checkAndStart();
        });
        window.mayraCode.handleMicClick(true);
      }
    } else {
      setIsMicModalActive(true);
      setIsMyRAIsActive(true);

      if (window.mayraCode) {
        window.setIsMicModalActive = setIsMicModalActive;
        window.updateMyRAIsActive = setIsMyRAIsActive;

        window.mayraCode.setOnMicEnabled((enabledBefore) => {
          // CLEAR THE CALLBACK IMMEDIATELY
          window.mayraCode.setOnMicEnabled(null);

          window.mayraCode.setIsVisible(true);

          const checkAndStart = () => {
            if (!window.trSessionId) {
              console.log("HomeScreen: No session ID found, starting new session.");
              AnalyticsService.startSession();
            }
            if (window.audioPlayer?.unlocked) {
              window.mayraCode.startFlow("flow_landing_page");
            } else {
              setTimeout(checkAndStart, 500);
            }
          };
          checkAndStart();
        });
        window.mayraCode.handleMicClick();
      }
    }
  }
}
